import { useIntl } from '@cmg/i18n';
import startCase from 'lodash/startCase';
import React from 'react';

import type { FundItem } from '../../../FundLevelDemand';
import { formatDemandItemValue } from '../FundIoisGridColumn.model';

export type Props = {
  ioi: FundItem['iois'][number];
};

export const DemandItem: React.FC<Props> = ({ ioi }) => {
  const intl = useIntl();
  const value = formatDemandItemValue(ioi, intl);

  const limit =
    ioi.pricingType === 'limit'
      ? intl.formatNumber(ioi.limitPrice, { format: 'currency' })
      : startCase(ioi.pricingType);

  return <span>{`${value} @ ${limit}`}</span>;
};
